import React from 'react';
import PropTypes from 'prop-types';
import entities from 'entities';
import { Col, Row } from 'react-grid-system';
import { PromoHighlightedWrapper, PromoHighlightedRow, PromoImageWrapper, PromoImage, PromoTitle, PromoSubTitle } from './styles';
import Label from '../shared/Label';

const flagImg = 'https://images2.gazzettaobjects.it/matchcenter/static/placeholder/placeholder-shield.svg';

const classLink = (promo) => {
  if (promo && promo.has('link') && promo.get('link') !== '') {
    return '';
  }
  return 'no-event';
};

const PromoHighlighted = ({ promohighlighted, isMobile }) => (
  <PromoHighlightedWrapper>
    {promohighlighted.map((promo, i) => (
      <PromoHighlightedRow
        key={i}
        className={classLink(promo)}
        href={promo.get('link')}
        target={promo.get('linkTarget')}
      >
        {promo.get('picPath') &&
          <PromoImageWrapper>
            <PromoImage
              src={promo.get('picPath')}
              onError={(e) => {
                e.target.src = flagImg;
              }}
            />
          </PromoImageWrapper>
        }
        <PromoTitle hasImage={promo.get('picPath')}>
          {entities.decodeHTML(promo.get('title'))}
          {promo.get('subtitle') &&
            <React.Fragment>
              : <PromoSubTitle>{promo.get('subtitle')}</PromoSubTitle>
            </React.Fragment>
          }
        </PromoTitle>
      </PromoHighlightedRow>
    ))}
  </PromoHighlightedWrapper>
);

PromoHighlighted.propTypes = {
  promohighlighted: PropTypes.any,
  isMobile: PropTypes.bool,
};

export default PromoHighlighted;
